<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>团队发货记录</span>
      </div>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="onChangeColumn">
              <el-option
                v-for="(item, i) in teamShipmentsRecord"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-select
              v-model="queryParams.value"
              v-if="queryParams.column==='deliverState' || queryParams.column==='deliverMode'"
            >
              <el-option
                v-for="(item, index) in selectList"
                :key="index"
                :label="item.lab"
                :value="item.val"
              ></el-option>
            </el-select>
            <el-date-picker
              v-else-if="queryParams.column==='outDate' || queryParams.column==='createDate'"
              style="width:100%"
              v-model="time"
              :default-time="['00:00:00','23:59:59']"
              value-format="yyyy-MM-dd HH:mm"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-input v-else v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item></el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        :max-height="$store.state.Sell.heightTitle"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="发货编号" fixed width="140">
          <template slot-scope="scope">
            <span class="approval" @click="toFaHuo(scope.row)">{{scope.row.deliverNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column label="出库单编号" width="136">
          <template slot-scope="scope">{{scope.row.outstockNumber||'--'}}</template>
        </el-table-column>
        <el-table-column label="合同编号" width="136">
          <template slot-scope="scope">
            <span class="approval" @click="toHeTong(scope.row)">{{scope.row.contractCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toKeHu(scope.row)"
            >{{ scope.row.cusName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="发货方式">
          <template slot-scope="scope">
            <span>{{scope.row.deliverMode}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mark" label="发货信息" width="210"></el-table-column>
        <el-table-column label="请求发货时间" width="125">
          <template slot-scope="scope">
            <span>{{scope.row.createDate|dateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="实际发货时间" width="125">
          <template slot-scope="scope">
            <span>{{scope.row.deliveryTime|dateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="发货状态">
          <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
        </el-table-column>
        <el-table-column prop="createUser" label="负责人"></el-table-column>
        <el-table-column prop="orgName" label="所属部门"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { teamShipmentsRecord } from './util/data'
import { shipmentsRecordTeam } from '@/api/sell/sellManage'
import pagination from '@/components/pagination'
export default {
  components: { pagination },
  data() {
    return {
      columnArr: [],
      deliverModeList: [
        { lab: '快递配送', val: '快递配送' },
        { lab: '物流配送', val: '物流配送' },
        { lab: '客户自提', val: '客户自提' },
        { lab: '直发', val: '直发' },
        { lab: '仓库配送', val: '仓库配送' }
      ], // 发货方式
      deliverStateList: [
        { lab: '审核中', val: 1 },
        { lab: '待发货', val: 2 },
        { lab: '已发货', val: 3 },
        { lab: '审核不通过', val: 4 }
      ], // 发货状态
      selectList: [],
      queryParams: {
        column: 'cusName',
        value: ''
      },
      teamShipmentsRecord, // 搜索下拉数据
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      time: [],
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams(val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onSearch() {
      // 搜索
      if (this.time.length === 2) {
        this.queryParams.value = this.time[0]
        this.queryParams.endValue = this.time[1]
      }
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset() {
      // 重置
      this.columnArr = []
      this.queryParams = {}
      this.pageSize = 30
      this.currentPage = 1
      this.getList()
    },
    // 发货详情
    toFaHuo(row) {
      this.$router.push({ name: 'shipmentsEdit', query: { ocdId: row.odgId } })
    },
    // 合同详情
    toHeTong(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.ocbId, cusId: row.cusId }
      })
    },
    // 客户详情
    toKeHu(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.cusId }
      })
    },
    getList() {
      this.loadingTable = true
      const obj = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      shipmentsRecordTeam(this.currentPage, this.pageSize, obj).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onChangeColumn(val) {
      // 改变下拉框
      this.time = []
      this.queryParams = {}
      this.queryParams.column = val
      if (this.queryParams.column === 'deliverMode') {
        this.selectList = this.deliverModeList
      }
      if (this.queryParams.column === 'deliverState') {
        this.selectList = this.deliverStateList
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
